import { useMutation } from '@tanstack/react-query';
import { createStripeSessionUrl } from 'shared/services/backend-api';
import { PriceInterval } from 'shared/types/price';

export const useStripeSessionUrlMutation = () =>
  useMutation({
    mutationFn: ({
      interval,
      discountCode,
      coupon,
    }: {
      interval: PriceInterval;
      discountCode?: string;
      coupon?: string;
    }) => createStripeSessionUrl({ interval, c: discountCode ?? coupon }),
  });
